import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registerServiceWorker } from './registerServiceWorker';

export function PwaUpdatePrompt() {
    const { t } = useTranslation();
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const updateRef = useRef<(() => Promise<void>) | null>(null);

    useEffect(() => {
        registerServiceWorker((applyUpdate) => {
            updateRef.current = applyUpdate;
            setIsUpdateAvailable(true);
        });
    }, []);

    if (!isUpdateAvailable) return null;

    const handleUpdate = () => {
        const applyUpdate = updateRef.current;
        if (applyUpdate) void applyUpdate();
    };

    return (
        <div className="toast toast-start toast-bottom z-999998">
            <div className="alert alert-info shadow-lg">
                <span>{t('pwa.updateAvailable')}</span>
                <div className="flex gap-2">
                    <button className="btn btn-sm btn-ghost" onClick={() => setIsUpdateAvailable(false)}>
                        {t('pwa.later')}
                    </button>
                    <button className="btn btn-sm btn-primary" onClick={handleUpdate}>
                        {t('pwa.update')}
                    </button>
                </div>
            </div>
        </div>
    );
}